import React, { useContext } from "react";
import { Switch, Route, withRouter, Redirect } from "react-router-dom";
import PersonalInfo from "./PersonalInfo";
import ModulesContext from "../ModulesContext";

function PersonalInfoIndex({ match, goToUpdate, goToDetail, onCancel, formComponent }) {
    const { permissions } = useContext(ModulesContext);

    return (
        <Switch>
            <Redirect exact from={match.path} to={`${match.path}/detail`} />
            {permissions.list.actions.add ? (
                <Route
                    exact
                    path={`${match.path}/add`}
                    render={(props) => (
                        <PersonalInfo
                            {...props}
                            mode="add"
                            title="Create File"
                            onCancel={onCancel}
                            goToUpdate={goToUpdate}
                            goToDetail={goToDetail}
                            formComponent={formComponent}
                        />
                    )}
                />
            ) : (
                <Redirect exact from={`${match.path}/add`} to={`${match.path}/detail`} />
            )}
            <Route
                exact
                path={`${match.path}/detail`}
                render={(props) => (
                    <PersonalInfo
                        {...props}
                        mode="detail"
                        title="Client File"
                        onCancel={onCancel}
                        goToUpdate={goToUpdate}
                        goToDetail={goToDetail}
                        formComponent={formComponent}
                    />
                )}
            />
            {permissions.personalInfo.actions.edit ? (
                <Route
                    exact
                    path={`${match.path}/update`}
                    render={(props) => (
                        <PersonalInfo
                            {...props}
                            mode="update"
                            title="Update File"
                            onCancel={onCancel}
                            goToUpdate={goToUpdate}
                            goToDetail={goToDetail}
                            formComponent={formComponent}
                        />
                    )}
                />
            ) : (
                <Redirect exact from={`${match.path}/update`} to={`${match.path}/detail`} />
            )}
        </Switch>
    );
}

export default withRouter(PersonalInfoIndex);
